import React, { useState, useEffect } from 'react';
import { createLink, updateLink } from '../api/api';
import '../index.css';
import './UserForm.css'; // Reuse UserForm CSS
import Form from './common/Form';
import Input from './common/Input';
import Button from './common/Button';
import Error from './common/Error';

const LinkForm = ({ link, onClose, onLinkUpdated, onLinkCreated }) => {
    const [formData, setFormData] = useState({
        text: '',
        url: '',
        accompaniment: false,
    });
    const [isEditing, setIsEditing] = useState(false);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState("");

    useEffect(() => {
        if (link) {
            setIsEditing(true);
            setFormData({
                text: link.text,
                url: link.url,
                accompaniment: link.accompaniment,
            });
        }
    }, [link]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newValue = type === 'checkbox' ? checked : value;
        setFormData({ ...formData, [name]: newValue });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setMessage("");

        try {
            if (isEditing) {
                const updatedLink = await updateLink(link.id, formData);
                if (updatedLink) {
                    onLinkUpdated(updatedLink);
                    setMessage("Link actualizado");
                }
            } else {
                const newLink = await createLink(formData);
                onLinkCreated(newLink);
                setMessage("Link creado");
            }
            setTimeout(() => {
                onClose();
            }, 1500);
        } catch (err) {
            setError(err.message || 'Error al procesar el link');
        }
    };

    return (
        <Form className='form-user' onSubmit={handleSubmit}>
            {message && <div className='container-message'>{message}</div>}
            {error && <Error error={error} />}
            <Input type="text" id="text" name="text" value={formData.text} onChange={handleChange} label="Nombre" required />
            <Input type="url" id="url" name="url" value={formData.url} onChange={handleChange} label="URL" required />
            <div>
                <label htmlFor="accompaniment">Acompañamiento</label>
                <input type="checkbox" id="accompaniment" name="accompaniment" checked={formData.accompaniment} onChange={handleChange} />
            </div>

            <Button type="submit">{isEditing ? 'Actualizar' : 'Crear'}</Button>
            <Button type='button' onClick={onClose}>Cancelar</Button>
        </Form>
    );
};

export default LinkForm;
